
import axios from 'axios'
import { configs } from '../common/config'
// import { isActiveSession, getToken, getActiveRemain } from './authHelper'
import { isActiveSession, getActiveRemain } from './authHelper'
import { useAccessControlStore } from '../store/modules/accessControlStore'
// import { useStore } from '../store'
// import store from '../store'
import * as _gFunc from './funcHelper'
import * as _gAuth from './authHelper'

/* INITIAL HTTP CLIENT EXTEND */
const httpClient = axios.create({
	// baseUrl: constVar.apiEndpoint,
	// timeout: 1000, // indicates, 1000ms ie. 1 second
	headers: {
		"Content-Type": "application/json",
		"Application-Code": _gAuth.appCode(),
		// "Access-Control-Allow-Origin": "*",
		// "Accept":"application/json"
		// anything you want to add to the headers
	}
});

/* HTTP REQUEST INTERCEPTOR */
const reqInterceptorHeader = (config,customHeader = {}) => {
	for (let key in customHeader) {
    config.headers.set(key, customHeader[key]);
	}
	return config;
}
const setCustomHeader = (customHeader,useBarier) => {
	if (_gFunc.isEmpty(customHeader)) customHeader = {}

	if(useBarier){
		customHeader['Auth-Id'] = 51;
		customHeader['Application-Code'] = 'sas_v2';
	}
	if (!_gFunc.isEmpty(customHeader)) {
		httpClient.interceptors.request.use(config=>reqInterceptorHeader(config,customHeader));
	} else {
		httpClient.interceptors.request.eject(reqInterceptorHeader);
	}
}
const interceptReqErrors = (err) => {
	console.log(err);
	return Promise.reject(err);
}
const interceptRequest = (config) => {
	return config;
};
httpClient.interceptors.request.use(interceptRequest, interceptReqErrors);	

const returnHandle = (resp, errorMessage = null) => {
	if (!_gFunc.isEmpty(resp?.status)) {
		if (resp.status < 300) {
			// _gFunc.hideLoading();
			return {
				data: resp.data,
				response_code: resp.status,
				success: true,
				message: resp.statusText,
			}
		} else {
			var errors = !_gFunc.isEmpty(resp?.data?.errors) ? resp.data.errors : resp.data;
			var errorMsg = !_gFunc.isEmpty(resp?.data?.message) ? resp.data.message : errorMessage;
			// console.log(resp);
			// _gFunc.hideLoading();
			return {
				data: errors,
				response_code: resp.status,
				success: false,
				message: errorMsg
			}
		}
	}else{
		// _gFunc.hideLoading();
		return {
			data: [],
			response_code: 999,
			success: false,
			message: "Unknow Error"
		}
	}
}
const refreshToken = async(refreshUrl) => {
	var resp = await httpPost(refreshUrl,{},true, false);
	if (resp?.success) {
		useAccessControlStore().setActiveUser(resp.data.user);
		useAccessControlStore().setActiveToken(resp.data);
	}
}
const checkToken = async (apiUrl) => {
	
	let refreshUrl = configs.services.access_control + configs.endPoint.access_control.refresh;
	if(apiUrl == refreshUrl) return true;

	let remaining = getActiveRemain();
	if (isActiveSession() && (remaining > 0) && (remaining < 10000)) {
		await refreshToken(refreshUrl);
	}
}
const buildQueryParams = (params) => {
  const searchParams = new URLSearchParams();

  const buildNestedParams = (obj, prefix = '') => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        const newKey = prefix ? `${prefix}[${key}]` : key;

        if (typeof value === 'object') {
          buildNestedParams(value, newKey);
        } else {
          searchParams.append(newKey, value);
        }
      }
    }
  };

  buildNestedParams(params);

  return searchParams.toString();
}

/* REQUEST METHODS */
export function httpPost(apiUrl, params = {}, useBarier = false, isShowLoad=true, customHeader={}) {
	if(isShowLoad){
		// _gFunc.showLoading();
	}
	// checkToken(apiUrl);
	setCustomHeader(customHeader,useBarier);
	return httpClient.post(apiUrl, params)
		.then((res) => {
			return returnHandle(res);
		})
		.catch((error) => {
			return returnHandle(error.response, error.message);
		});
}
export function httpPut(apiUrl, params = {}, useBarier = false, isShowLoad=true, customHeader={}) {
	if(isShowLoad){
		// _gFunc.showLoading();
	}
	checkToken(apiUrl);
	setCustomHeader(customHeader,useBarier);
	return httpClient.put(apiUrl, params)
		.then((res) => {
			return returnHandle(res);
		})
		.catch((error) => {
			return returnHandle(error.response, error.message);
		});
}
export function httpGet(apiUrl, params = {}, useBarier = false, isShowLoad=true, customHeader={}) {
	if(isShowLoad){
		// _gFunc.showLoading();
	}	
	checkToken(apiUrl);
	setCustomHeader(customHeader,useBarier);
	if(!_gFunc.isEmpty(params)){
		let newParams  = buildQueryParams(params);
		apiUrl = apiUrl + '?' + newParams;
	}

	return httpClient.get(apiUrl)
		.then((res) => {
			return returnHandle(res);
		})
		.catch((error) => {
			return returnHandle(error.response, error.message);
		});
}
export function httpDelete(apiUrl, useBarier = false, isShowLoad=true, customHeader={}) {
	if(isShowLoad){
		// _gFunc.showLoading();
	}
	checkToken(apiUrl);
	setCustomHeader(customHeader,useBarier);
	return httpClient.delete(apiUrl)
		.then((res) => {
			return returnHandle(res);
		})
		.catch((error) => {
			return returnHandle(error.response, error.message);
		});
}
export function clientRefreshToken(){
	refreshToken();	
}
export function getResponse(resp,defaultValue = {}){
	if(resp.success){
		return resp;
	}else{
		//SHOW ALERT
		alert(resp.message);

		return defaultValue;
	}
}
